import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'category', label: 'Type' },
  { key: 'original_name', label: 'File' },
  { key: 'notes', label: 'Notes' },
  { key: 'uploaded_on', label: 'Uploaded On' },
];

export function DocumentsRegisterReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Employee Documents Register"
      description="Every document held on an employee's file, by type."
      endpoint="/reports/hr/documents"
      columns={COLUMNS}
      filters={['category', 'dateRange']}
      categoryOptions={listOptions(lists, 'employee_document_type')}
      listColumns={{ category: 'employee_document_type' }}
    />
  );
}
